// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay ul.location-hours[data-v-e906338e]{list-style:none;padding-left:1rem}#openbay ul.location-hours li[data-v-e906338e]{font-weight:700;margin-bottom:.5rem;position:relative}#openbay ul.location-hours span[data-v-e906338e]{color:#616a76;font-weight:400;position:absolute;left:60px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
